import { render } from "./DischargePatient.vue?vue&type=template&id=3685d790&scoped=true"
import script from "./DischargePatient.vue?vue&type=script&lang=js"
export * from "./DischargePatient.vue?vue&type=script&lang=js"

import "./DischargePatient.vue?vue&type=style&index=0&id=3685d790&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3685d790"]])

export default __exports__